import { Box } from '@mui/material';
import React from 'react';
import ASTITitle from '../../labels/ASTITitle';
import ASTIText from '../../labels/ASTIText';
import ASTILink from '../../labels/ASTILink';

export default function Shows() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      gap={4}
    >
      <ASTITitle text="Upcoming Dates" />
      
      <ASTIText text="Contact and/or book us !! Follow us and send us a DM on Instagram -> @astir.oids" />
      
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="80%"
        gap={2}
      >
        
        <ASTIText text="Lyrical Knockout - Party for the Animals - Leiden - Mar 5th" />
        <ASTILink url="https://zerowastefestival.nl/leiden/" text="Lyrical Knockout - Zero Waste Festival - Leiden - Mar 20th" />
        <ASTIText text="Lyrical Knockout - Gang of Parrots - OT301 - Amsterdam - May 9th" />
        <ASTILink url="https://impronation.nl/index.php/shows/" text="Lyrical Knockout - ImproNation - Den Haag - May 29th 2026" />

      </Box>

      <ASTITitle text="Past Dates" />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="80%"
        gap={2}
      >
        <ASTIText text="1st Collab with Nomadic Sounds - Amsterdam - Feb 6th" />
        <ASTIText text="Lyrical Knockout - Attic Collective - Boom Chicago - Jan 17" />
        <ASTIText text="Surrogate - Humans & Friends - MiniFest - Cinetol - 14 Dec" />
        <ASTIText text="Lyrical Knockout - Impro Lab - A Lab - 10 Dec 25" />
        <ASTIText text="[Special] - Sasha Hoedemaker Appreciation Show - Boom Chicago - 23 Nov 25" />
        <ASTIText text="Surrogate - Humans & Friends - Jam with Humans - Parlour - 13 Oct 25" />
        <ASTIText text="Lyrical Knockout - ImproNation - Den Haag - 3rd Oct 25" />
        <ASTIText text="[Special] Dystopia - Mike's Badhuistheater - 1st Oct 25" />
        <ASTIText text="Lyrical Knockout - Big Sing Festival - Barcelona - 28 June 25" />
        <ASTIText text="Surrogate - Humans & Friends - Parlour - 15 Jun 25" />
        <ASTIText text="Surrogate - Humans & Friends - Parlour - 11 May 25" />
        <ASTIText text="Lyrical Knockout - Supermercator - 09 May 25" />
        <ASTIText text="Lyrical Knockout w Cliffs of Dover - Boomspijker - 19 Apr 25" />
        <ASTIText text="Surrogate - Humans & Friends - Parlour - 13 Apr 25" />
        <ASTIText text="Lyrical Knockout - ImproNation Den Haag - 21 Mar 25" />
        <ASTIText text="Lyrical Knockout - Thuisparty - Boom Chicago - 23 Feb 25" />
        <ASTIText text="Lyrical Knockout - Showjam - Impro Eindhoven - 14 Feb 25" />
        <ASTIText text="Lyrical Knockout w Jam with Humans - Spark Rotterdam - 30 Jan 25" />
        <ASTIText text="Lyrical Knockout - Ruby Hotel - 19 Dec 24" />
        <ASTIText text="Lyrical Knockout - Bar BaggerBeest - 14th of December 24" />
        <ASTIText text="Lyrical Knockout - The Parlour - 8th of December 24" />
        <ASTIText text="[Special] Lazer Lazer - OT301 - Ventilator Cinema - 6th of December 24" />
        <ASTIText text="Lyrical Knockout w Jam with Humans – The Parlour – 3rd of November 2024" />
        <ASTIText text="[Special] Land of Giants – Easylaughs - CREA Muziekzaal – 1st of November 2024" />
        <ASTIText text="Lyrical Knockout - Jam with Humans – The Parlour – 22nd of September 2024" />
        <ASTIText text="2-year Anniversary Show – OT301/Ventilator Cinema – 14th of September 2024" />
        <ASTIText text="Jam with Humans – The Parlour – 8th of September 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 1st of June 2024" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 2nd of May 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 24th of March 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 7th of November 2023" />
        <ASTIText text="Jam with Humans – Q-Factory – 13th of October 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 12th of October 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 7th of September 2023" />
        <ASTIText text="Boom Chicago Comedy Festival – Boom Chicago – 16th of July 2023" />
        <ASTIText text="Easylaughs – CREA Muziekzaal - 2nd of June 2023"  />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 18th of May 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 30th of March 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 16th of February 2023" />
        <ASTIText text="[Inception] Boom Chicago Comedy Festival – Boom Chicago – 17th of July 2022" />
        
      </Box>

    </Box>
  );
}
